import _extends from "@babel/runtime/helpers/extends";
import { forwardRef, useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { EditorView } from '@codemirror/view';
import { jsx as _jsx } from "react/jsx-runtime";
var defalutTheme = document.documentElement.getAttribute('data-color-mode');
export var CodeEditor = /*#__PURE__*/forwardRef((props, ref) => {
  var borderRadius = EditorView.theme({
    '.cm-scroller, &': {
      borderRadius: '6px'
    },
    '&': {
      border: '1px solid var(--color-border-default)'
    }
  });
  var {
    extensions = [],
    theme: pTheme
  } = props;
  var [theme, setTheme] = useState(pTheme || defalutTheme);
  useEffect(() => {
    var val = document.documentElement.getAttribute('data-color-mode');
    setTheme(val);
    document.addEventListener('colorschemechange', e => {
      setTheme(e.detail.colorScheme);
    });
  }, []);
  return /*#__PURE__*/_jsx(CodeMirror, _extends({
    ref: ref
  }, props, {
    style: {
      padding: 1
    },
    extensions: [borderRadius, ...extensions],
    theme: theme
  }));
});